import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { responseStatus } from 'config/constants';
import { showAlert } from 'reducers/alertReducer';
import { getErrorMessage } from 'utils/common';

/** Only handle the first 401 when multiple APIs return 401; avoids duplicate logout/alert. Does not affect 503/404/default handling. */
let isHandling401 = false;

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  headers: {
    'content-type': 'application/json'
  },
  prepareHeaders: (headers, { getState, endpoint }) => {
    if (endpoint === 'uploadToS3') return headers;
    const basename = window.location.pathname.indexOf('/admin') !== -1 ? 'admin' : 'front';
    const token = localStorage.getItem(basename === 'front' ? 'userToken' : 'adminToken');
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }

    return headers
  },
});

export const customBaseQuery = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)
  if (result.error) {
    switch (result.error.status) {
    case 503: {
      if (result?.error?.data?.maintenance === true) {
        const maintenancePath = window.location.pathname.indexOf('/admin') !== -1 ? '/admin/maintenance' : '/maintenance';;
        if (!window.location.pathname.startsWith(maintenancePath)) {
          window.location.replace(maintenancePath);
        }
      }
      api.dispatch({ type: 'HIDE_LOADING' })
      break;
    }
    case responseStatus.UNAUTHORITY: {
      if (isHandling401) {
        api.dispatch({ type: 'HIDE_LOADING' });
        break;
      }
      isHandling401 = true;
      api.dispatch({ type: 'RESET_AUTH' });
      const message = getErrorMessage(result?.error?.error || result?.error?.data?.message);
      setTimeout(() => {
        api.dispatch({ type: 'HIDE_LOADING' });
        api.dispatch(showAlert({ type: 'error', message }));
        isHandling401 = false;
      }, 500);
      break;
    }
    case responseStatus.NOT_FOUND:
      api.dispatch({ type: 'REDIRECT_NOT_FOUND' })
      api.dispatch({ type: 'HIDE_LOADING' })
      break;
    default:
      api.dispatch(
        showAlert({
          type: 'error',
          message: getErrorMessage(result?.error?.error || result?.error?.data?.message),
        })
      )
      api.dispatch({ type: 'HIDE_LOADING' })
      break;
    }
  }
  api.dispatch({ type: 'RESET_REDIRECT_NOT_FOUND' })
  return result;
}